var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.power(_vm.userInfo.menuInfoList, 'link-export'))?_c('el-button',{staticClass:"el-icon-upload2",attrs:{"type":"primary","size":"small"},on:{"click":_vm.toExport}},[_vm._v("导出")]):_vm._e(),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.download}},[_vm._v("下载所有环节资源")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }